import { useState } from "react";

import styles from "./FulfillmentPriorityErrorToast.module.css";

interface FulfillmentPriorityErrorToastProps {
  summary: string;
  details: string[];
  viewDetailsLabel: string;
  hideDetailsLabel: string;
  detailsLabel: string;
}

export function FulfillmentPriorityErrorToast({
  summary,
  details,
  viewDetailsLabel,
  hideDetailsLabel,
  detailsLabel,
}: FulfillmentPriorityErrorToastProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.content}>
      <p className={styles.summary}>{summary}</p>

      <button
        className={styles.toggleButton}
        type="button"
        aria-expanded={expanded}
        onClick={(event) => {
          event.stopPropagation();
          setExpanded((currentValue) => !currentValue);
        }}
      >
        {expanded ? hideDetailsLabel : viewDetailsLabel}
      </button>

      {expanded && (
        <div className={styles.details} role="region" aria-label={detailsLabel}>
          <ul className={styles.detailsList}>
            {details.map((detail, index) => (
              <li key={`${index}-${detail}`}>{detail}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
